import React, { useEffect, useState } from 'react'
import { whiteCard } from '../common/cssclasses'
import EahsForm from '../components/EahsForm'
import axios from '../axios/axiosUmbraco';

export default function PresidentWord() {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const [wordObj, setWordObj] = useState({});
    const id = process.env.REACT_APP_UMBRACO_EAHS_PRESIDENT_WORD_ID;


    async function getDetails() {
        try {
            const umbraco = await axios.get(`/umbraco/delivery/api/v1/content/item?id=${id}`, {
                
            })
            debugger;
            const formattedData = umbraco.data?.map((item) => ({
                title: item?.properties?.title ?? '',
                description: item?.properties?.description ?? '',
                createdBy: item?.properties?.createdBy ?? '',
                position: item.properties?.position,
                companyName: item?.properties?.companyName ?? "",
            }));

            if (formattedData.length > 0) {
                setWordObj(formattedData[0]);
            }
        } catch (error) {
            console.error('error in getting president Word' , error);
        }
    }

    useEffect(()=>{
        getDetails();
    },[])


    return (
        <>
            <EahsForm>
                <div className='col-lg-12 col-md-12 col-sm-12'>
                    {!!wordObj?.title &&
                        <h3 className='NewsPostTitle bold'>
                            {wordObj?.title}
                        </h3>
                    }
                </div>
                {!!wordObj?.description &&
                    <div className='col-lg-12 col-md-12 col-sm-12 my-3'>
                        <div className='NewsPostBody' style={{ textAlign: 'justify' }} >
                            {wordObj?.description}
                        </div>
                    </div>
                }

                <div className='col-lg-3 col-md-4 col-sm-12 ms-auto'>
                    {!!wordObj?.createdBy &&
                        <h6 className='NewsPostTitle bold text-center'>
                            {wordObj?.createdBy}
                        </h6>
                    }
                    {!!wordObj?.position &&
                        <h6 className='NewsPostTitle bold text-center'>
                            {wordObj?.position}
                        </h6>
                    }
                    {!!wordObj?.companyName &&
                        <h6 className='NewsPostTitle bold text-center'>
                            {wordObj?.companyName}
                        </h6>
                    }
                </div>
            </EahsForm>
        </>
    )
}
